'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { calculateProfileStrength } from '../../Utils/profileStrength.js';
import { getProfileLevel } from '../service.js';
import { EApplyType, DEFAULT_ALLOW_EXT } from '../type.js';
import { RadioCss, RadioBox, Label, Link, TextResume } from '../Styled.css.js';
import { ALLOW_SEARCHABLE } from '../const.js';

function Radio(_a) {
    var _this = this;
    var resume = _a.resume, type = _a.type, checked = _a.checked, onClick = _a.onClick, t = _a.t, accessToken = _a.accessToken, langCode = _a.langCode, baseUrl = _a.baseUrl, baseMsUrl = _a.baseMsUrl, attachmentInfo = _a.attachmentInfo, setIsDisable = _a.setIsDisable;
    var _b = useState(0), percent = _b[0], setPercent = _b[1];
    var percentProfileStrength = function (profileLevel) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var profileLevelItem = {
            level: (_b = (_a = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _a === void 0 ? void 0 : _a.resumeLevelId) !== null && _b !== void 0 ? _b : 0,
            passedPoints: (_d = (_c = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _c === void 0 ? void 0 : _c.currentPoint) !== null && _d !== void 0 ? _d : 0,
            totalPoints: (_f = (_e = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _e === void 0 ? void 0 : _e.totalPoint) !== null && _f !== void 0 ? _f : 0,
            status: (_h = (_g = profileLevel === null || profileLevel === void 0 ? void 0 : profileLevel.attributes) === null || _g === void 0 ? void 0 : _g.resumeStatus) !== null && _h !== void 0 ? _h : ''
        };
        var percent = (_j = calculateProfileStrength(profileLevelItem)) !== null && _j !== void 0 ? _j : 0;
        if (percent) {
            var parseIntPercent = parseInt(percent.toFixed(0));
            setPercent(parseIntPercent);
        }
    };
    var getProfileStrengthByProfileLevel = function () { return __awaiter(_this, void 0, void 0, function () {
        var profileLevel, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getProfileLevel(accessToken, langCode, baseMsUrl)];
                case 1:
                    profileLevel = _a.sent();
                    if (profileLevel) {
                        percentProfileStrength(profileLevel);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var TextEllipsis = function (text) {
        var fileName = '';
        var extName = '';
        DEFAULT_ALLOW_EXT.split(',').forEach(function (ext) {
            var isInCludes = text.includes(ext);
            if (isInCludes) {
                extName = ext;
                fileName = text.replace(ext, '');
            }
        });
        return (React__default.createElement(TextResume, null,
            React__default.createElement("span", null, fileName),
            extName));
    };
    useEffect(function () {
        if (type === EApplyType.online) {
            getProfileStrengthByProfileLevel();
        }
    }, []);
    var renderRadio = function (type) {
        var _a, _b, _c, _d;
        switch (type) {
            case EApplyType.online:
                return (React__default.createElement(Label, null,
                    React__default.createElement("p", null, t('Hồ Sơ VietnamWorks')),
                    React__default.createElement("div", null,
                        React__default.createElement("p", null,
                            React__default.createElement(Link, { href: "".concat(baseUrl, "/").concat(t('ho-so')), target: '_blank' }, t('Xem hồ sơ')),
                            ' ',
                            percent ? "".concat(percent, "% ").concat(t('hoàn thiện')) : null))));
            case EApplyType.lastAttachment:
                return (React__default.createElement(Label, null,
                    React__default.createElement("p", null,
                        t('Hồ Sơ Đính Kèm'),
                        ":"),
                    React__default.createElement("div", null,
                        React__default.createElement("p", null,
                            React__default.createElement(Link, { href: (_a = attachmentInfo === null || attachmentInfo === void 0 ? void 0 : attachmentInfo.link) !== null && _a !== void 0 ? _a : '', target: '_blank' }, TextEllipsis((_b = resume === null || resume === void 0 ? void 0 : resume.text) !== null && _b !== void 0 ? _b : '')),
                            ' ',
                            "- ", (_c = resume === null || resume === void 0 ? void 0 : resume.hint) !== null && _c !== void 0 ? _c : ''))));
            case EApplyType.newAttachment:
                return (React__default.createElement(Label, null,
                    React__default.createElement("p", null,
                        t('Hồ Sơ Vừa Tải Lên'),
                        ":"),
                    React__default.createElement("div", null,
                        React__default.createElement("p", null, TextEllipsis((_d = resume === null || resume === void 0 ? void 0 : resume.text) !== null && _d !== void 0 ? _d : '')))));
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    return (React__default.createElement(RadioCss, { onClick: function () {
            onClick(type);
            setIsDisable((resume === null || resume === void 0 ? void 0 : resume.allowSearchableDisplay) !== ALLOW_SEARCHABLE);
        }, className: checked ? 'active' : '' },
        React__default.createElement(RadioBox, { className: checked ? 'checked' : '' }),
        renderRadio(type !== null && type !== void 0 ? type : EApplyType.newAttachment)));
}

export { Radio as default };
//# sourceMappingURL=Radio.js.map
